<template>
  <base-layout pageTitle="Impressum">
    Impressum
  </base-layout>
</template>

<script>
export default {
  name: 'ImpressumPage',
};
</script>

<style scoped>
/* Add any custom styles for Datenschutz here */
</style>